export default __webpack_public_path__ + "static/Side_Scroll-a5f63b60b100c2285dcdbf7008ebd32d.svg";